import React, { useState, useEffect } from 'react';

const AddTaskModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ title: '', date: '', time: '', tag: 'Email' });

  useEffect(() => {
    if (open) {
      const today = new Date().toISOString().split('T')[0];
      const now = new Date();
      now.setHours(now.getHours() + 1);
      now.setMinutes(0);
      setForm({ title: '', date: today, time: now.toTimeString().slice(0, 5), tag: 'Email' });
    }
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="add-task-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">+</div>
        <div className="modal-title">Tambahkan Task Baru</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>Jadwalkan aktivitas dan tugas Anda.</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Judul Task</label>
            <input type="text" className="form-control" required placeholder="Contoh: Follow up kontrak client"
              value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
              data-testid="add-task-title" />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Tanggal</label>
              <input type="date" className="form-control" required value={form.date}
                onChange={e => setForm({ ...form, date: e.target.value })}
                data-testid="add-task-date" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Waktu</label>
              <input type="time" className="form-control" required value={form.time}
                onChange={e => setForm({ ...form, time: e.target.value })}
                data-testid="add-task-time" />
            </div>
          </div>
          <div className="form-group">
            <label>Kategori (Tag)</label>
            <select className="form-control form-select" value={form.tag}
              onChange={e => setForm({ ...form, tag: e.target.value })}
              data-testid="add-task-tag">
              <option value="Email">Email</option>
              <option value="Call">Call</option>
              <option value="Meeting">Meeting</option>
              <option value="Doc">Document</option>
              <option value="Internal">Internal</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="add-task-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="add-task-submit">Simpan Task</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTaskModal;
